<template>
  <ModalContainer :show="show" @close="onCancel">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <template slot="header">
      <h4 class="mb-0">{{ $t(`add-${type}`) }}</h4>
    </template>

    <template slot="body">
      <form class="p-2" @submit.prevent="addorigin">
        <div class="entry-type">
          <label>Entry type</label>
          <select v-model="entryType">
            <option value="" hidden selected>Select</option>
            <option
              v-for="option in entryTypeOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
        <div v-if="entryType">
          <div
            style="display: flex; justify-content: space-between; gap: 1rem"
            v-if="entryType === 'direct'"
          >
            <div style="width: 100%">
              <div class="form-group">
                <label for="name"> {{ $t("company_name") }}</label>
                <input
                  type="text"
                  name="name"
                  v-model="direct.companyName"
                  class="form-control"
                  required
                  id="name"
                  :placeholder="$t('enter-company-name')"
                  style="text-transform: capitalize"
                  @keypress="isLetter($event)"
                />
              </div>

              <div class="form-group">
                <label for="country"> {{ $t("country") }} </label>
                <CountrySelect
                  class="form-control"
                  required
                  id="country"
                  v-model="direct.country"
                  :countryLabel="'Select a Country'"
                  :countryName="true"
                />
              </div>
              <div class="form-group">
                <label for="lga"> {{ $t("lga-country") }} </label>
                <input
                  type="text"
                  v-model="direct.lga"
                  class="form-control"
                  placeholder="Enter LGA/Country"
                  name="lga"
                />
              </div>
            </div>

            <div style="width: 100%">
              <div class="form-group">
                <label for="phoneNum">
                  {{ $t("phone_num") }} {{ $t("optional") }}
                </label>
                <input
                  type="tel"
                  name="phoneNum"
                  class="form-control"
                  id="phone_number"
                  :placeholder="$t('enter-phonenumber')"
                  v-model="direct.phoneNumber"
                />
              </div>

              <div class="form-group">
                <label for="state"> {{ $t("state_province") }} </label>
                <RegionSelect
                  class="form-control"
                  required
                  id="state"
                  v-model="direct.state"
                  :regionName="true"
                  :country="getCountryCode"
                  default-region="Select a Region"
                />
              </div>

              <div class="form-group">
                <label for="address"> {{ $t("address") }}</label>
                <input
                  type="text"
                  name="address"
                  class="form-control"
                  required
                  id="autocomplete"
                  :placeholder="$t('enter-address')"
                  ref="autocompleteInput"
                  @input="onInputChange"
                  v-model="address"
                />
              </div>
            </div>
          </div>
          <div
            style="display: flex; justify-content: space-between; gap: 1rem"
            v-if="entryType === 'port'"
          >
            <div style="width: 100%">
              <div class="form-group">
                <label for="name"> {{ $t("port_type") }}</label>
                <select
                  v-model="port.type"
                  class="form-control"
                  :disabled="isAddShipment"
                >
                  <option value="" disabled hidden>Select</option>
                  <option
                    v-for="option in portTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div>

              <div class="form-group port-select">
                <label for="port"> {{ $t("port") }} </label>
                <div
                  class="form-control port-select-container"
                  @click="showPorts = !showPorts"
                >
                  {{ port.name ? truncateText : "    Select" }}
                </div>
                <div
                  class="port-box"
                  v-if="showPorts"
                  v-click-outside="closeShowPort"
                >
                  <div class="port-box-search">
                    <SearchIcon />
                    <input
                      type="text"
                      placeholder="Search"
                      class="port-box-input"
                      v-model="searchQuery"
                      @input="filterPorts"
                    />
                  </div>
                  <ul class="port-options">
                    <li
                      v-for="option in portOptions"
                      :key="option.id"
                      @click.stop="handleSelectPort(option)"
                    >
                      {{ option.location || option.name }}
                    </li>
                  </ul>
                </div>
                <!-- <select v-model="direct.state" class="form-control">
                  <option value="" disabled hidden>Select</option>
                  <option v-for="option in states" :key="option.value">
                    {{ option.label }}
                  </option>
                </select> -->
              </div>
            </div>

            <div style="width: 100%">
              <div class="form-group">
                <label for="portCountry"> {{ $t("country") }} </label>
                <CountrySelect
                  class="form-control"
                  required
                  id="portCountry"
                  v-model="port.country"
                  :country="port.country"
                  :countryLabel="'Select a Country'"
                  :defaultOption="'Select a country'"
                  :countryName="true"
                />
              </div>
              <div class="form-group">
                <label for="portPhone">
                  {{ $t("phone_num") }} {{ $t("optional") }}</label
                >
                <input
                  type="tel"
                  name="portPhone"
                  class="form-control"
                  :placeholder="$t('enter-phonenumber')"
                  v-model="port.phoneNumber"
                />
              </div>
            </div>
          </div>
        </div>
        <div type="submit" class="btn-add">
          <button
            :disabled="!isValidLocation"
            :class="{
              'invalid-button': !isValidLocation,
              'valid-button': isValidLocation,
            }"
          >
            {{ $t("add") }}
          </button>
        </div>
      </form>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { CountrySelect, RegionSelect } from "vue-country-region-select";
import countries from "./../../assets/json/country.json";
import * as intlTelInput from "./../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";
import vClickOutside from "v-click-outside";

export default {
  name: "AddDestination",
  components: {
    ModalContainer,
    Loading,
    CountrySelect,
    RegionSelect,
  },
  props: {
    show: Boolean,
    onCancel: Function,
    type: String,
    isAddShipment: {
      type: Boolean,
      default: false,
    },
    directives: {
      clickOutside: vClickOutside.directive,
    },
    newShipmentDestination: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isLoading: false,
      fullPage: true,

      company: "",
      region: "",
      personOfContact: "",
      mssg: "",
      Errormssg: "",
      country: "Nigeria",

      lat: null,
      lng: null,

      address: "",
      previousAddress: "",
      isClearing: false,
      isValidLocation: false,
      showPorts: false,
      entryType: "",
      allPorts: [],
      portTypes: [
        { label: "Seaport", value: "sea" },
        { label: "Airport", value: "air" },
      ],

      localGovts: [
        {
          value: "irewole",
          label: "Irewole",
        },
      ],
      portOptions: [],
      direct: {
        companyName: "",
        phoneNumber: "",
        address: "",
        state: "",
        country: "",
        lga: "",
      },
      port: {
        type: "",
        country: "",
        port: "",
        phoneNumber: "",
        name: "",
      },
      searchQuery: "",
      entryTypeOptions: [
        {
          label: "Direct Address Entry",
          value: "direct",
        },
        { label: "Port Selection", value: "port" },
      ],
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.initializeAutocomplete();
    // });
  },
  computed: {
    ...mapGetters(["ports", "getShipmentType"]),
    getCountryCode() {
      return countries.find((c) => c.name === this.direct.country)?.code;
    },
    truncateText() {
      if (!this.port.location) return "Select";
      const charLimit = 25;
      return this.port.location.length > charLimit
        ? this.port.location.slice(0, charLimit) + " ..."
        : this.port.location;
    },
  },
  methods: {
    ...mapActions([
      "addDestination",
      "getDestinations",
      "getAllPorts",
      "getOrigin",
      "addOrigin",
    ]),

    validateLocation() {
      if (this.entryType === "port" || !this.entryType)
        this.isValidLocation = true;
      else
        this.isValidLocation =
          this.lat !== null &&
          this.lng !== null &&
          this.lat >= -90 &&
          this.lat <= 90 &&
          this.lng >= -180 &&
          this.lng <= 180;
    },
    handleSelectPort(selected) {
      this.port.port = selected.id;
      this.port.name = selected.name;
      this.port.location = selected.location || selected.name;
      this.port.address = this.isAddShipment ? selected.address : undefined;
      this.closeShowPort();
    },
    closeShowPort() {
      if (this.showPorts) this.showPorts = false;
    },
    filterPorts() {
      const query = this.searchQuery.toLowerCase();
      this.portOptions = this.allPorts.filter(
        (port) =>
          port.name.toLowerCase().includes(query) ||
          port.location.toLowerCase().includes(query)
      );
    },
    onInputChange() {
      this.isClearing = this.address.length < this.previousAddress.length;

      this.previousAddress = this.address;

      if (this.isClearing || !this.address) {
        this.lat = null;
        this.lng = null;
      }

      this.validateLocation();
    },

    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },
    initializeAutocomplete() {
      const { google } = window;
      this.geocoder = new google.maps.Geocoder();
      const input = document.getElementById("autocomplete");
      const autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (place && place.formatted_address) {
          // The address was found in the autocomplete list
          this.address = place.formatted_address;

          // Get latitude and longitude from the place object
          const latLng = place.geometry?.location;

          if (latLng) {
            this.lat = latLng.lat();
            this.lng = latLng.lng();
          }
        } else {
          // The address was not in the autocomplete list, use geocoding
          const inputAddress = document.getElementById("autocomplete").value;

          // Use the Geocoder to get latitude and longitude for the entered address
          this.geocoder.geocode(
            { address: inputAddress },
            (results, status) => {
              if (
                status === google.maps.GeocoderStatus.OK &&
                results.length > 0
              ) {
                const result = results[0];

                const latLng = result.geometry.location;
                this.lat = latLng.lat();
                this.lng = latLng.lng();
              } else {
                console.error("Geocoding failed:", status);
              }
            }
          );
        }
        this.validateLocation();
      });
    },
    addorigin() {
      this.isLoading = true;

      const inputAddress = document.getElementById("autocomplete")?.value;

      let payload = null;
      if (this.entryType === "direct") {
        payload = {
          name: this.direct.companyName,
          address: inputAddress
            ? {
                name: document.getElementById("autocomplete").value,
                lng: this.lng,
                lat: this.lat,
              }
            : undefined,
          region: this.direct.state,
          country: this.direct.country,
          personOfContact: this.direct.phoneNumber,
          entry: this.entryType,
          county: this.direct.lga,
        };
      }
      if (this.entryType === "port") {
        payload = {
          name: this.port.name,
          country: this.port.country,
          entry: this.entryType,
          personOfContact: this.port.phoneNumber,
          port: this.port.port,
          address: this.port.address,
        };
      }

      if (this.isAddShipment && this.type === "destination") {
        return this.$emit("newDestination", payload);
      }
      if (this.isAddShipment && this.type === "origin")
        return this.$emit("newOrigin", payload);
      if (this.type === "destination") {
        this.addDestination(payload)
          .then((res) => {
            this.getDestinations();
            this.isLoading = false;
            this.onCancel();
            this.$emit("showSuccessPopup", {
              msg: this.$t("add_destination_mssg"),
              heading: this.$t("add_destination_heading"),
            });
          })
          .catch((error) => {
            console.error("Error adding origin:", error);
            this.isLoading = false;
            this.Errormssg = "Error adding origin. Please try again.";
          });
      }

      if (this.type === "origin") {
        this.addOrigin(payload)
          .then((res) => {
            this.getOrigin();
            this.isLoading = false;
            this.onCancel();
            this.$emit("showSuccessPopup", {
              msg: this.$t("add_origin_mssg"),
              heading: this.$t("add_origin_heading"),
            });
          })
          .catch((error) => {
            console.error("Error adding origin:", error);
            this.isLoading = false;
            this.Errormssg = "Error adding origin. Please try again.";
          });
      }
    },
  },
  watch: {
    "port.country": function (newVal) {
      if (this.port.type && newVal) {
        this.getAllPorts({
          type: this.port.type,
          country: newVal.toLowerCase(),
        })
          .then((res) => {
            this.portOptions = res.data?.payload?.data;
            this.allPorts = res.data?.payload?.data;
          })
          .catch((err) => console.log(err));
      }
    },
    entryType: function (newVal) {
      if (newVal === "direct") {
        this.validateLocation();
        this.$nextTick(() => {
          this.initializeAutocomplete();
        });
      } else {
        this.isValidLocation = true;
      }
    },

    "port.type": function (newVal) {
      if (this.port.country) {
        this.getAllPorts({
          type: newVal,
          country: this.port.country.toLowerCase(),
        })
          .then((res) => {
            this.portOptions = res.data?.payload?.data;
            this.allPorts = res.data?.payload?.data;
          })
          .catch((err) => console.log(err));
      }
      // this.fetchData();
    },
    newShipmentDestination: {
      handler(newValues) {
        if (newValues.address && this.isAddShipment) {
          this.$nextTick(() => {
            const autocompleteInput = this.$refs.autocompleteInput;
            if (autocompleteInput) {
              this.name = newValues.name || "";
              this.address = newValues.address.name || "";
              this.region = newValues.region || "";
              this.country = newValues.country || "";
              this.lat = newValues.address.lat || 0;
              this.lng = newValues.address.lng || 0;
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    newShipmentOrigin: {
      handler(newValues) {
        if (newValues.address && this.isAddShipment) {
          this.$nextTick(() => {
            const autocompleteInput = this.$refs.autocompleteInput;
            if (autocompleteInput) {
              this.name = newValues.name || "";
              this.address = newValues.address.name || "";
              this.region = newValues.region || "";
              this.country = newValues.country || "";
              this.lat = newValues.address.lat || 0;
              this.lng = newValues.address.lng || 0;
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },

    isAddShipment: {
      handler(newVal) {
        if (newVal) {
          this.port.type = this.getShipmentType;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.port-select {
  position: relative;
}
.port-box {
  position: absolute;
  background-color: #fff;
  box-shadow: 2px 2px 30px 0px #a3abb933;
  padding: 24px 16px;
  border-radius: 10px;
}
.port-box-input {
  border: 1px solid #b7c3cd;
  background-color: #fff !important;
  padding-left: 10px;
  height: 32px;
}
.port-select-container {
  background: rgba(240, 244, 251, 0.6) !important;
  color: #404a57;
  text-transform: capitalize;
}
.port-options {
  list-style: none;
  margin-top: 8px;
  display: grid;
  padding: 0px;
}
.port-options li {
  padding-block: 10px;
  color: #404a57;
  text-transform: capitalize;

  border-bottom: 0.75px solid #0000001a;
}
.port-box-input::placeholder {
  color: #b7c3cd;
  font-size: 14px;
  font-weight: 400;
}
.port-box-search {
  position: relative;
}
.port-box-search svg {
  position: absolute;
  top: 50%;
  bottom: 50%;
  transform: translateY(-50%);
  left: 10px;
}
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}

.valid-button {
  background-color: rgba(33, 62, 122, 1);
  cursor: pointer;
}

.invalid-button {
  background-color: rgba(33, 62, 122, 0.8);
}
.entry-type {
  display: grid;
  /* gap: 8px; */
}
.entry-type select {
  width: 100%;
  height: 50px;
  margin-bottom: 24px;
}
</style>
